// extracted by mini-css-extract-plugin
export default {"formBtn":"styles_formBtn__JLJdD"};